import React from "react";
import { Context, Hooks, Util } from "@xt/xtbase";
import styles from "./ConvertBuy/index.module.less";

const { XtAuth } = Context;
const { useTranslation } = Hooks;
const { getUrl } = Util;

/** Figma Input content：Preview 主按钮（345×48） */
export default function ConvertFormFooter({ canPreview = false, onPreview, loginQuery, previewErrorKey = null }) {
  const t = useTranslation();
  const showPreviewAmountError = previewErrorKey === "convert.errorAmountTooSmallAfterFees";

  return (
    <div className={styles["convert-buy__form-footer"]}>
      <div className={styles["convert-buy__preview-wrap"]}>
        <XtAuth
          renderNotLogin={() => (
            <a href={getUrl("/accounts/register" + loginQuery)} className={styles["convert-buy__preview-btn"]}>
              {t("convert.previewOrder")}
            </a>
          )}
          renderLogin={() => (
            <button
              type="button"
              className={`${styles["convert-buy__preview-btn"]} ${!canPreview ? styles["convert-buy__preview-btn--disabled"] : ""}`}
              onClick={() => canPreview && onPreview?.()}
              disabled={!canPreview}
            >
              {t("convert.previewOrder")}
            </button>
          )}
        />
      </div>
      {showPreviewAmountError && (
        <p className={styles["convert-buy__preview-hint"]}>{t(previewErrorKey)}</p>
      )}
    </div>
  );
}
